module.exports = __webpack_public_path__ + "media/images/client/video_icon-2845c9a248c37b8d694b5c8b95e2ee5c.png";